import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: any[]) {
  return twMerge(clsx(...inputs))
}

export * from './email-grouping'
export * from './format-storage'
export * from './mailbox-scale'
export * from './free-sample-opportunity'
